import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { ArrowDownUp } from 'react-bootstrap-icons';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { getUsername } from '../../app/AuthService';
import { HouseDoorFill } from 'react-bootstrap-icons';

import Button from '@designSystem/Button';
import Spinner from '@designSystem/Spinner';
import HeaderCardCustom from '@features/eligibility/HeaderCardCustom';
import { fixMismatchRequest } from './reducer/geoMatchSlice';
import {
  ConfirmAddressText,
  ConfirmArrowsIcon,
  ConfirmCustomBody,
  ConfirmCustomCard,
  ConfirmStyledFooter,
  ConfirmSeparator
} from './styles/ConfirmStyles';
import { IPEcolor, BANcolor } from './styles/common';

import { selectIPEInfos, selectBANInfos } from './reducer/geoMatchSlice';

const GeoMatchConfirm: React.FC<{
  backToStart: () => void;
}> = ({ backToStart }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const IPEaddress = useAppSelector(selectIPEInfos);
  const BANaddress = useAppSelector(selectBANInfos);

  const { t } = useTranslation();

  useEffect(() => {
    if (IPEaddress && BANaddress) {
      setLoading(true);

      dispatch(
        fixMismatchRequest({
          identifiant_immeuble: IPEaddress.identifiant_immeuble,
          code_adresse: BANaddress.code_adresse,
          ipe_address: IPEaddress.name,
          ban_address: BANaddress.name,
          created_by: getUsername()
        })
      ).then(() => {
        setLoading(false);
      });
    }
  }, [IPEaddress, BANaddress]);

  return (
    <>
      {loading && <Spinner spinnerSize={2} center />}
      <ConfirmCustomCard
        header={
          <HeaderCardCustom
            titleHeader={t(
              'features.geomatch.confirmedChange',
              'Your fix mismatch request has been acknowledged.'
            )}
            subTitleHeader={t('features.geomatch.matchBetween', 'Link done between: ')}
          />
        }
        footer={
          <ConfirmStyledFooter>
            <Button design="plain" onClick={backToStart}>
              {t('component.button.backToStart', 'Get back to the start')}
            </Button>
          </ConfirmStyledFooter>
        }
      >
        <ConfirmCustomBody>
          <ConfirmAddressText color={IPEcolor}>
            <span>
              {IPEaddress?.name}
              {IPEaddress?.batiment_immeuble && (
                <>
                  <HouseDoorFill size="13" />
                  <>{IPEaddress.batiment_immeuble}</>
                </>
              )}
            </span>
          </ConfirmAddressText>
          <ConfirmSeparator>
            <ConfirmArrowsIcon>
              <ArrowDownUp />
            </ConfirmArrowsIcon>
          </ConfirmSeparator>
          <ConfirmAddressText color={BANcolor}>{BANaddress?.name}</ConfirmAddressText>
        </ConfirmCustomBody>
      </ConfirmCustomCard>
    </>
  );
};

export default GeoMatchConfirm;
